import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getMobileNavLocationKey } from '../mobile-nav-location-key';

export const useMobileNav = () => {
  const location = useLocation();
  // 같은 pathname 안에서 query 하위 메뉴로 이동해도 Drawer를 닫아야 한다.
  const locationKey = getMobileNavLocationKey(location);
  const [open, setOpen] = useState(false);

  const handlePathnameChange = useCallback(() => {
    if (open) {
      setOpen(false);
    }
  }, [open]);

  useEffect(() => {
      handlePathnameChange();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locationKey]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    handleOpen,
    handleClose,
    open
  };
};
